import { createContext } from "react";
import { CommonDataResult } from "@apiHooks/useCommonData";
import { getResponsiveScale } from "@core/getResponsiveScale";

type GlobalContextType ={
    getRem: (value: number) => number;
    commonData: CommonDataResult;
}

export const GlobalContext = createContext<GlobalContextType>({
    getRem: (px: number) => getResponsiveScale(px, 0),
    commonData: {
        data: [],
        isLoading: false,
    },
});